module.exports = __webpack_public_path__ + "img/tree-fire-flame-03-c.3e1ec4fa.png";